<template>
	<div>
		<el-dialog title="准考证打印" :visible.sync="isShowModal" :close-on-click-modal="false" width="1200px" @close="closeDialog">
			<div style="text-align: right; position: absolute; top:20px; right: 100px;">
				<el-button v-print="'#printMe'" icon="el-icon-printer" @click="scaleZkz" type="primary">打印</el-button>
			</div>
			<div id="printMe" style="width: 1118px; height: 793px;  margin: 0 auto; ">
				<div  style="width: 560px; height: 700px; margin-left: 25px; padding-top: 45px; overflow: hidden;  ">
					<div id="zkz"
						style=" width: 700px;  margin: 0 auto; height: 1400px;  overflow: hidden; transform: scale(0.7,0.7); transform-origin: left top; text-align: center; " v-html="printHtml">
					</div>
				</div>
				
			</div>
			
		</el-dialog>
	</div>
</template>

<script>

	export default {

		props:{
			stuid:0
		},
		data() {
			return {
				isShowModal: true,
				stuinfo:{
					stu_name:"",
					stu_code:"",
					major_name:"",
					xuezhi:"",
					yuanxi_name:"",
					gender:""
				},
				fee:{
					xuefei:0,
					total:0,
					other:[]
				},
				teacherInfo:{
					username:""
				},
				date:"",
				printHtml:"",
				duanluo:{
					editp:"",
					p1:"经我校招生办公室审查合格，省、市招生委员会批准你被录取到我校学习，请持此录取通知书于2021年9月3日，到我校报到。",
					p2:"南京高等职业技术学校 招生办公室",
					p3:"",
					p4:"",
					p5:"",
					p6:"",
				}
			}
		},
		mounted() {
			let d=new Date();

			this.date = d.getFullYear()+"年"+(d.getMonth()+1)+"月"+d.getDate()+"日"
			this.duanluo.p3 = this.date
			this.teacherInfo =JSON.parse( sessionStorage.getItem("userinfo"))
			this.getInfo()
			
		},
		methods: {
			
			scaleZkz(){
				let html = '';
				let type = type ? type : 1;
							
				html = '<style type="text/css" media="print">\n' + '  \n' + '</style>';
				//console.log(html)
				//@page { size: landscape; }
				$('#printMe').append(html);
				//$("#zkz").animate({transfrom:"scale(0.5,0.5)"},50,function(){})
			},
			getTemp(){
				
				this.$http.post("/api/t_sch_printer_list",{ktype:"ptype",keyword:"zkz",n_pmid:this.$store.state.pmid}).then(res=>{
					let printHtml = res.data[0].pjson;
					printHtml = printHtml.replace(/\${学生编号}/g,this.stuinfo.stu_code)
					printHtml = printHtml.replace(/\${学生姓名}/g,this.stuinfo.stu_name)
					
					printHtml = printHtml.replace(/\${专业}/g,this.stuinfo.major_name)
					printHtml = printHtml.replace(/\${学制}/g,this.stuinfo.major.item_desc)

					printHtml = printHtml.replace(/\${今日日期}/g,this.date)
					printHtml = printHtml.replace(/\${身份证号}/g,this.stuinfo.identity_card)
					printHtml = printHtml.replace(/\${考试号}/g,this.stuinfo.exam_num)
					printHtml = printHtml.replace(/\${建档号}/g,this.stuinfo.archive)
					printHtml = printHtml.replace(/\${学生性别}/g,this.stuinfo.gender==1?'男':'女')
					printHtml = printHtml.replace(/\${准考证号}/g,this.stuinfo.exam_num)
					printHtml = printHtml.replace(/\${分数}/g,this.stuinfo.exam_score)
					printHtml = printHtml.replace(/\${学生电话}/g,this.stuinfo.phone)
					printHtml = printHtml.replace(/\${学生电话2}/g,this.stuinfo.phone2)
					printHtml = printHtml.replace(/\${办理人}/g,this.teacherInfo.username)
					printHtml = printHtml.replace(/\${报道须知号}/g,this.stuinfo.fee_idx)
					printHtml = printHtml.replace(/\${缴费序号}/g,this.stuinfo.fee_idx)
					//printHtml = printHtml.replace(/\${考点}/g,this.stuinfo.pjson.kaodian)
					//printHtml = printHtml.replace(/\${考场}/g,this.stuinfo.pjson.kaochang)
					this.printHtml = printHtml
					this.$http.post("/api/app_platform_info").then(app=>{

						this.printHtml = this.printHtml.replace(/\${学校名称}/g,app.data.platform)
						this.$nextTick(()=>{
							if(this.stuinfo.pjson.dzzj){
								$("#dzzj","#printMe").attr("src",this.stuinfo.pjson.dzzj+"?x-oss-process=image/resize,w_200")
								this.scaleZkz()
							}
						})
					})
				})


			},
			getInfo(){
				this.$http.post("/api/sch_student_pre_info",{id:this.stuid}).then(res=>{
					if(res.data.pjson&&typeof(res.data.pjson)=="string"){
						res.data.pjson = JSON.parse(res.data.pjson)
					}else if(res.data.otherjson&&typeof(res.data.otherjson)=="string"){
						res.data.pjson = JSON.parse(res.data.otherjson)
					}
					if(!res.data.major){
						res.data.major={}
					}
					this.stuinfo = res.data
					//计算缴费信息
					this.getTemp()

				})
			},
			closeDialog(){
				this.$parent.stuIdx=0
			}
		}
	}
</script>

<style scoped="scoped">
	.uline{ text-decoration: underline;}
</style>
